// NGXS
import { Action, Selector, State, StateContext } from '@ngxs/store';
import {
  ASetUserPrivileges,
  ASetAdminFacilitiesId,
} from '../actions/user-privileges.action';
import {
  IUserPrivileges,
  IFacilityInformation,
} from 'src/app/models/service/user-privileges.model';
import { Injectable } from '@angular/core';

// Models and interfaces

export interface UserPrivilegesStateI {
  userPrivileges: IUserPrivileges;
  adminFacilitiesId: IFacilityInformation[];
}

@State<UserPrivilegesStateI>({
  name: 'UserPrivilegesState',
  defaults: {
    userPrivileges: null,
    adminFacilitiesId: [],
  },
})
@Injectable({
  providedIn: 'root',
})
export class UserPrivilegesState {
  @Selector()
  static getUserPrivilegesState(
    state: UserPrivilegesStateI,
  ): UserPrivilegesStateI {
    return state;
  }

  @Action(ASetUserPrivileges)
  setUserPrivileges(
    { patchState }: StateContext<UserPrivilegesStateI>,
    { payload }: ASetUserPrivileges,
  ): void {
    patchState({
      userPrivileges: payload,
    });
  }

  @Selector()
  static getAdminFacilitiesIdState(
    state: UserPrivilegesStateI,
  ): IFacilityInformation[] {
    return state.adminFacilitiesId;
  }

  @Action(ASetAdminFacilitiesId)
  SetAdminFacilitiesId(
    { patchState }: StateContext<UserPrivilegesStateI>,
    { payload }: ASetAdminFacilitiesId,
  ): void {
    patchState({
      adminFacilitiesId: [...payload],
    });
  }
}
